module.exports = __webpack_public_path__ + "static/media/mapfre-economics-white-bg.3e521782.jpg";